import { Link } from "react-router-dom";
import { formatHeat, getHotAnime } from "@/utils/anime";

export default function HotRanking() {
  const hotList = getHotAnime(8);

  return (
    <aside className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3.5 border-b border-background-200">
        <h2 className="font-heading font-extrabold text-foreground-950 text-lg flex items-center gap-2">
          <i className="ri-fire-fill text-primary-500"></i>
          热门排行榜
        </h2>
        <span className="text-xs text-foreground-400">实时热度</span>
      </div>

      <ol className="p-2">
        {hotList.map((anime, i) => (
          <li key={anime.id}>
            <Link
              to={`/detail/${anime.id}`}
              className="flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors group"
            >
              <span
                className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-bold ${
                  i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <div className="w-10 h-14 shrink-0 rounded overflow-hidden bg-background-200">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {anime.title}
                </p>
                <p className="text-[11px] text-foreground-500 mt-0.5 truncate">
                  {anime.category} · {anime.status}
                </p>
              </div>
              <span className="text-[11px] text-accent-700 font-medium whitespace-nowrap flex items-center gap-0.5">
                <i className="ri-fire-line"></i>
                {formatHeat(anime.heat)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}